import { InputLabel, styled } from "@mui/material";

export const StyledFieldLabel = styled(InputLabel)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "120%",
  color: theme.palette.gray[10],
  marginBottom: "4px",
}));
